module.exports = __webpack_public_path__ + "img/stop_btn.f2487a88.png";